module.exports = __webpack_public_path__ + "img/as.4662508e.png";